import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrdersComponent } from './pages/orders/orders.component';
import { OrderComponent } from './pages/order/order.component';
import { CanDeactivateGuard } from 'src/app/shared/guards/can-deactivate-guard';

const routes: Routes = [
  {
    path: '',
    component: OrdersComponent,
  },
  {
    path: 'order/:id',
    component: OrderComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'order',
    component: OrderComponent,
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderRoutingModule {}
